import { Injectable, Inject } from '@angular/core';
import { Http, Headers, RequestOptionsArgs, Response } from '@angular/http';
import { CookieService } from './cookie';

@Injectable()
export class CryptoService {

    constructor
    () {}


    encryptNumber(param: number)
    {
        let prefix = "xyZ";
        let sufix = "xpNw";
        let output = "";

        try
        {
            if (param != null)
            {
                let newNumber = param + 1264;
                output = prefix + newNumber.toString() + sufix;
            }
        }
        catch (Exception)
        {
            throw Exception;
        }

        return output;
    }

    decryptNumber(encryptedString: string)
    {
        let output = -1;
        
        try
        {
            if (encryptedString != null || encryptedString != "")
            {
                let stringWithoutPrefix = encryptedString.substring(3, encryptedString.length);

                let stringwithoutSufix =  stringWithoutPrefix.substring(0, stringWithoutPrefix.length - 4);
                
                output = Number(stringwithoutSufix) - 1264;
            }
        }
        catch (Exception)
        {
            throw Exception;
        }

        return output;
    }

    decryptString(text: string)
    {
        text = text.substring(4, text.length);
        text = text.substring(0, text.length - 4);
        let decryptedText = '';

        for(let c of text)
        {
            let unicode = c.charCodeAt(0);
            unicode -= 5;

            decryptedText += String.fromCharCode(unicode);
        }

        return decryptedText;
    }

}



// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/services/core/crypto.service.ts